import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";

export const ExcludeSearch = withLiteObserverAndTheme<{
  onClick: () => void;
  state: boolean;
  isDisabled: boolean;
}>((props) => {
  const { onClick, state, isDisabled } = props;

  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={state}
          disabled={isDisabled}
          onChange={onClick}
        />
      }
      label={i18n.get("EXCLUDE")}
      slotProps={{ typography: { variant: "body2" } }}
      sx={{ m: 0, gap: 1 }}
    />
  );
});

export default ExcludeSearch;
